export default {
  common: {
    error: "Jokin meni pieleen",
    reload: "Lataa uudelleen",
    errorNotification: "Olemme saaneet ilmoituksen ja korjaamme sen mahdollisimman pian. Jos ongelma jatkuu, ota yhteyttä",
    contactUs: "meihin.",
    language: "Kieli",
    loading: "Ladataan...",
    loadingText: "Ladataan",
    save: "Tallenna",
    savedSuccessfully: "Tallennettu Onnistuneesti",
    saving: "Tallennetaan...",
    cancel: "Peruuta",
    edit: "Muokkaa",
    delete: "Poista",
    add: "Lisää",
    search: "Etsi",
    filter: "Suodata",
    clear: "Tyhjennä",
    preview: "Esikatselu",
    default: "Oletus: {{value}}",
    optional: "Valinnainen",
    required: "Pakollinen",
    noData: "Ei tietoja",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Sijainnit",
      cities: "Kaupungit", 
      regions: "Alueet",
      countries: "Maat",
      showOnMap: "Näytä kartalla",
      addLocation: "Lisää sijainti"
    },
    welcome: {
      title: "Tervetuloa Locations So Super -palveluun.",
      subtitle: "Valitse navigaatiosta osio aloittaaksesi."
    }
  },

  // Cities section
  cities: {
    title: "Kaupungit",
    resourceSingular: "kaupunki",
    resourcePlural: "kaupungit",
    headings: {
      name: "Nimi",
      status: "Tila",
      locations: "Sijainnit", 
      region: "Alue",
      country: "Maa"
    },
    breadcrumbs: {
      cities: "Kaupungit"
    }
  },

  // Countries section  
  countries: {
    title: "Maat",
    resourceSingular: "maa", 
    resourcePlural: "maat",
    headings: {
      name: "Nimi",
      status: "Tila",
      locations: "Sijainnit",
      cities: "Kaupungit",
      regions: "Alueet"
    },
    breadcrumbs: {
      countries: "Maat"
    }
  },

  // Regions section
  regions: {
    title: "Alueet",
    resourceSingular: "alue",
    resourcePlural: "alueet", 
    headings: {
      name: "Nimi",
      status: "Tila",
      locations: "Sijainnit",
      cities: "Kaupungit",
      country: "Maa"
    },
    breadcrumbs: {
      regions: "Alueet"
    }
  },

  // Map section
  map: {
    title: "Kartta",
    breadcrumbs: {
      locations: "Sijainnit"
    }
  },

  // Import section
  import: {
    title: "CSV-tuonti",
    breadcrumbs: {
      locations: "Sijainnit"
    },
    new: {
      title: "Tuo sijainnit CSV:llä",
      description: "Lataa esimerkki CSV-pohja nähdäksesi vaaditun muodon esimerkin",
      sampleTemplate: "esimerkki CSV-pohja",
      uploadAndContinue: "Lataa ja jatka",
      abortOnError: "Keskeytä virheessä",
      abortOnErrorHelp: "Jos virhe ilmenee, tuonti keskeytyy, näyttää virheen eikä sijainteja tuoda.",
      needHelp: "Tarvitsetko apua sijainteja tuodessa?"
    },
    show: {
      title: "CSV-tuonti",
      youCanLeavePage: "Voit jättää tämän sivun",
      backgroundMessage: "Tuottisi jatkaa taustalla",
      importProgress: "Tuonnin edistyminen",
      imported: "Tuotu",
      suffix: "sijaintia",
      importLog: "Tuonnin loki",
      cancelImport: "Peruuta tuonti",
      cancelConfirmation: {
        title: "Peruuta tuonti",
        message: "Oletko varma, että haluat peruuttaa tämän tuontityön? Tätä toimintoa ei voi kumota.",
        note: "Huom: Käynnissä oleville töille työn on suoritettava loppuun ja se poistetaan heti sen jälkeen.",
        yesCancel: "Kyllä, peruuta tuonti",
        noContinue: "Ei, jatka tuontia"
      },
      report: "Raportti",
      failedLocations: "Epäonnistuneet sijainnit",
      uploadAnother: "Lataa toinen CSV",
      backToLocations: "Takaisin sijainteihin",
      importSucceeded: "Tuonti onnistui",
      importFailed: "Tuonti epäonnistui"
    },
    messages: {
      uploadSuccess: "CSV ladattu onnistuneesti",
      uploadError: "CSV:tä ei voitu ladata",
      pending: "Tuonti ei ole vielä alkanut",
      inProgress: "Tuonti käynnissä",
      completed: "Tuonti valmis",
      invalidHeader: "Seuraavat sarakkeet vaaditaan",
      invalidCsvFile: "Virheellinen CSV-tiedosto",
      aborted: "Tuonti keskeytetty",
      failed: "Tuonti epäonnistui",
      cancelled: "Tuonti peruutettu"
    },
    errors: {
      csvTooLarge: "CSV on liian suuri",
      languageNotEnabled: "Kieli '{{language}}' ei ole käytössä tälle kaupalle. Ota se käyttöön Asetukset > Kielet ensin.",
      fieldNotTranslatable: "Kenttä '{{field}}' ei ole käännettävissä. Käännettävät kentät ovat: {{fields}}",
      locationError: "Sijainti slugilla: {{slug}} - {{error}}",
      planLimit: "Olet suunnitelmasi sijaintirajoituksessa"
    }
  },

  // Location form
  location: {
    index: {
      title: "Sijainnit",
      addLocation: "Lisää sijainti",
      import: "Tuo",
      noPrioritySet: "Prioriteettia ei asetettu",
      published: "Julkaistu",
      draft: "Luonnos",
      resourceSingular: "sijainti",
      resourcePlural: "sijainnit",
      headings: {
        name: "Nimi",
        status: "Tila", 
        city: "Kaupunki",
        region: "Alue",
        country: "Maa",
        priority: "Prioriteetti"
      }
    },
    form: {
      title: "Lisää sijainti",
      editTitle: "Muokkaa sijaintia",
      basicInformation: "Perustiedot",
      name: "Nimi",
      namePlaceholder: "esim. Brianin Tiilet",
      nameHelpDefault: "Oletus: {{defaultName}}",
      details: "Yksityiskohdat",
      description: "Kuvaus",
      descriptionPlaceholder: "Kerro asiakkaille, mikä tekee tästä sijainnista erityisen",
      address: "Osoite",
      addressPlaceholder: "123 Pääkatu, Kaupunki, Maa",
      addressLine1: "Osoiterivi 1",
      addressLine2: "Osoiterivi 2",
      postalZipCode: "Postinumero",
      city: "Kaupunki",
      stateProvinceRegion: "Osavaltio / Provinssi / Alue",
      country: "Maa",
      phone: "Puhelin",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Sähköposti", 
      emailPlaceholder: "store@example.com",
      website: "Verkkosivusto",
      websitePlaceholder: "https://www.example.com",
      image: "Kuva",
      imagePlaceholder: "Syötä kuvan URL",
      status: "Tila",
      statusActive: "Aktiivinen",
      statusInactive: "Ei-aktiivinen",
      statusDraft: "Luonnos",
      priority: "Prioriteetti",
      priorityHelpText: "Korkeamman prioriteetin sijainnit näkyvät ensin hakutuloksissa",
      findOnMapButton: "Etsi kartalta"
    },
    validation: {
      addressNotFound: "Osoitetta ei löytynyt",
      createSuccess: "Sijainti luotu onnistuneesti", 
      updateSuccess: "Sijainti päivitetty onnistuneesti",
      checkFields: "Tarkista kenttäsi",
      findOnMap: "Etsi sijaintisi kartalta ennen tallentamista"
    },
    errors: {
      loading: "Virhe sijainnin lataamisessa"
    },
    actions: {
      save: "Tallenna sijainti",
      delete: "Poista sijainti",
      preview: "Esikatselu"
    },
    customFields: {
      title: "Mukautetut kentät",
      noCustomFields: "Ei mukautettuja kenttiä määritetty",
      configureFields: "Määritä kentät",
      emptyState: "Et ole vielä määrittänyt yhtään mukautettua kenttää. Mukautetut kentät antavat sinun lisätä lisätietoja, jotka ovat erityisiä liiketoimintatarpeillesi."
    },
    openingHours: {
      title: "Aukioloajat",
      checkboxLabel: "Tällä sijainnilla on aukioloajat ja sulkemisajat",
      statusOpen: "Avoinna",
      statusOpen24h: "Avoinna 24h",
      statusClosed: "Suljettu",
      openingTimeLabel: "Aukioloaika",
      closingTimeLabel: "Sulkemisaika",
      days: {
        monday: "Maanantai",
        tuesday: "Tiistai", 
        wednesday: "Keskiviikko",
        thursday: "Torstai",
        friday: "Perjantai",
        saturday: "Lauantai",
        sunday: "Sunnuntai"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Äskettäin lisätty",
        recentlyModified: "Äskettäin muokattu"
      },
      filters: {
        status: "Tila",
        taggedWith: "Tunnistettu",
        locationStatus: "Sijainnin tila",
        noTagsToShow: "Ei näytettäviä tunnisteita",
        searchPlaceholder: "Etsi"
      },
      bulkActions: {
        setPublished: "Aseta julkaistuksi",
        setUnpublished: "Aseta julkaisemattomaksi", 
        setPriority: "Aseta prioriteetti",
        deleteLocations: "Poista sijainnit",
        exportCSV: "Vie CSV:nä"
      },
      appliedFilters: {
        statusIs: "Tila on {{status}}",
        taggedWith: "Tunnistettu {{tag}}",
        nameIncludes: "Nimi sisältää {{search}}"
      },
      modals: {
        deleteTitle: "Poista sijainnit",
        deleteMessage: "Oletko varma, että haluat poistaa {{count}}?",
        deleteMessageAll: "Oletko varma, että haluat poistaa kaikki sijainnit?",
        prioritiseTitle: "Priorisoi {{count}} sijaintia",
        prioritiseTitleAll: "Priorisoi kaikki sijainnit",
        delete: "Poista",
        cancel: "Peruuta"
      },
      emptyState: {
        noResultsHeading: "Ei löytynyt yhtään {{resourcePlural}}",
        noResultsText: "Kokeile muuttaa suodattimia tai hakusanaa",
        noDataHeading: "Lisää sijainti täyttääksesi {{resourcePlural}}",
        addLocation: "Lisää sijainti",
        importFromCSV: "Tuo CSV:stä"
      },
      pagination: {
        label: "Sivu {{page}} / {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Päivitetty onnistuneesti",
        deletedSuccessfully: "Poistettu onnistuneesti", 
        exportedSuccessfully: "Viety onnistuneesti",
        error: "Jokin meni pieleen"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Sivun sisältö",
    editTemplate: "Muokkaa SEO-pohjaa", 
    pageTitle: "Otsikko",
    pageDescription: "Kuvaus",
    metaTitle: "Otsikko",
    metaDescription: "Kuvaus",
    urlHandle: "URL-kahva",
    searchEnginePreview: "Hakukoneen listauksen esikatselu",
    editMeta: "Muokkaa meta-tietoja",
    previewMeta: "Esikatsele meta-tietoja",
    loading: "Ladataan...",
    editingLocaleHelp: "Muokataan {{locale}}-sisältöä."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-pohjat",
    breadcrumbs: {
      seoTemplates: "SEO-pohjat"
    },
    template: {
      title: "{{templateName}} pohja - {{locale}}",
      discardChanges: "Hylkää muutokset"
    },
    form: {
      pageContent: "Sivun sisältö",
      searchEnginePreview: "Hakukoneen listauksen esikatselu",
      title: "Otsikko",
      description: "Kuvaus",
      pageTitle: "Sivun otsikko",
      metaDescription: "Meta-kuvaus",
      editingLocaleHelp: "Muokataan {{locale}}-käännöksiä. Tyhjät kentät näyttävät sisältöä {{defaultLocale}}:sta.",
      defaultValue: "Oletus: {{value}}"
    },
    language: {
      label: "Kieli",
      defaultHelp: "Tämä on oletuskielesi",
      editingHelp: "Muokataan {{locale}}-käännöksiä. Tyhjät kentät näyttävät {{defaultLocale}}-sisältöä."
    },
    banner: {
      multipleLanguagesDisabled: "Useita kieliä ei ole käytössä",
      enableInSettings: "Ota käyttöön asetuksissa",
      multipleLanguagesInfo: "Hallitaksesi SEO-pohjia useille kielille, ota kansainvälistäminen käyttöön kieliasetuksissasi. Näytetään tällä hetkellä vain {{locale}}-pohjia."
    },
    badges: {
      errors: "Virheitä!",
      unsaved: "Tallentamaton"
    },
    messages: {
      saveSuccess: "SEO-pohjat tallennettu onnistuneesti",
      saveError: "Pohjia ei voitu tallentaa",
      error: "Virhe..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Perustiedot",
      name: "Nimi",
      save: "Tallenna",
      saving: "Tallennetaan...",
      cancel: "Peruuta",
      yourLocationsIn: "Sijaintisi {{name}}:ssa",
      tableHeadings: {
        name: "Nimi",
        status: "Tila",
        city: "Kaupunki",
        region: "Alue",
        country: "Maa"
      },
      resourceName: {
        singular: "{{name}} sijainti",
        plural: "sijainnit {{name}}:ssa"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Kartta",
      tags: "Tunnisteet",
      customFields: "Mukautetut kentät",
      languages: "Kielet",
      plan: "Suunnitelma",
      addTag: "Lisää tunniste",
      addField: "Lisää kenttä"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Päättyy pian"
    },
    common: {
      loading: "Ladataan...",
      error: "Virhe...",
      breadcrumbs: {
        settings: "Asetukset"
      },
      skeleton: {
        customFields: "Mukautetut kentät",
        addField: "Lisää kenttä",
        name: "Nimi",
        contentType: "Sisältötyyppi",
        usedIn: "Käytetty",
        field: "Kenttä",
        fields: "Kentät"
      },
      messages: {
        savedSuccessfully: "{{setting}} asetukset tallennettu onnistuneesti",
        couldntSave: "{{setting}} asetuksia ei voitu tallentaa"
      }
    },
    map: {
      title: "Kartta",
      messages: {
        savedSuccessfully: "Kartta-asetukset tallennettu onnistuneesti",
        couldntSave: "Asetuksia ei voitu tallentaa"
      },
      mapboxToken: {
        title: "Mapbox-tunnus",
        description: "Syötä Mapbox-tunnuksesi käyttääksesi myymälän sijainnin etsintää",
        label: "Mapbox-tunnus",
        placeholder: "Syötä tunnus tähän jatkaaksesi kartan käyttöä.",
        placeholderManaged: "Syötä tunnus tähän jatkaaksesi kartan käyttöä, kun ilmaiset karttalataukset loppuvat.",
        helpText: "Seuraa ohjeitamme Mapbox-avaimen luomiseen, sitten liitä avaimesi yllä. Jos kohtaat ongelmia, ota yhteyttä saadaksesi apua.",
        linkInstructions: "ohjeet Mapbox-avaimen luomiseen",
        linkSupport: "ota yhteyttä saadaksesi apua"
      },
      managedToken: {
        title: "Karttalataukset",
        description: "Sinulla on enintään {{max}} ilmaista karttalatausta hallitulla tunnuksella, sen jälkeen sinun täytyy luoda oma tunnuksesi."
      },
      appearance: {
        title: "Ulkoasu",
        description: "Muuta karttasi visuaalista ulkoasua"
      },
      mapStyle: {
        title: "Karttatyyli",
        options: {
          streets: "Kadut",
          outdoors: "Ulkoilu", 
          light: "Vaalea",
          dark: "Tumma",
          satellite: "Satelliitti",
          satelliteStreets: "Satelliittikadut",
          navigationDay: "Navigointi päivä",
          navigationNight: "Navigointi yö"
        }
      },
      searchBehaviour: {
        title: "Hakukäyttäytyminen",
        description: "Hallitsee, miten vierailijat löytävät sijainnit kartaltasi.",
        geolocateLabel: "Arvioi automaattisesti vierailijan sijainti ja näytä lähellä olevat myymälät",
        geolocateHelp: "Jos paikannus onnistuu, kartta siirtyy keskittymään vierailijan lähelle. Jos arvioitua sijaintia ei löydy, kartta pysyy aloitusasennossa.",
        filterBehaviour: {
          title: "Suodattimen käyttäytyminen",
          all: {
            label: "Kaikki tunnisteet",
            help: "Sijainnin näkyäksesi suodattimissa sen täytyy olla kaikki valitut tunnisteet"
          },
          any: {
            label: "Mikä tahansa tunniste", 
            help: "Sijainnin näkyäksesi suodattimissa sen voi olla mikä tahansa valituista tunnisteista"
          }
        },
        keepSearchInView: {
          label: "Pidä hakumerkki näkyvissä",
          help: "Kun hakutulokset ilmestyvät, kartta loittonee näyttääkseen kaikki vastaavat sijainnit"
        },
        distanceUnits: {
          title: "Etäisyysyksiköt",
          km: "Kilometrit",
          miles: "Mailit"
        },
        maxResults: {
          label: "Enimmäistulokset",
          help: "Rajoita hakutuloksissa näytettävien sijainnien määrää",
          options: {
            results30: "30 tulosta"
          }
        },
        maxDistance: {
          label: "Enimmäisetäisyys", 
          help: "Näytä vain tämän etäisyyden sisällä olevat sijainnit hakupisteestä",
          options: {
            unlimited: "Rajoittamaton"
          }
        },
        showLocationNames: {
          label: "Näytä sijainnin nimet ehdotuksissa",
          help: "Näytä sijainnin nimet hakuehdotuksissa"
        },
        sortByPriority: {
          label: "Järjestä prioriteetin mukaan etäisyyden sijaan",
          help: "On erittäin suositeltavaa asettaa enimmäisetäisyys (joka ei ole Rajoittamaton), jos tämä ruutu on valittu. Muuten asiakkaasi näkevät kaukaisia sijainteja, joilla on korkea prioriteetti, listattuna niiden sijainnien yläpuolella, jotka ovat kohtuullisen etäisyyden päässä heistä (tai heidän hakukyselystään tarkemmin sanottuna)."
        }
      },
      searchResults: {
        title: "Hakutulokset",
        description: "Hallitsee, miten sijainnit palautetaan kartallasi.",
        locationsLabel: "Hakutulosten teksti",
        locationsHelp: "Teksti, joka näytetään hakutulosten yläpuolella (esim. 'Näytetään 5 sijaintia')",
        prefixLabel: "Hakutulosten etuliite", 
        prefixHelp: "Teksti, joka näytetään tulosten määrän edessä"
      },
      popups: {
        title: "Ponnahdusikkunat",
        showPopups: {
          label: "Näytä ponnahdusikkunat",
          help: "Näytä sijainnin yksityiskohdat, kun vierailijat klikkaavat karttamerkkejä"
        }
             },
       whitelabel: {
         title: "Valkoinen merkintä",
         hideLabel: "Piilota 'Powered by' -teksti",
         hideHelp: "Poista brändäyksemme myymälän sijainnin etsijästäsi"
       }
    },
    languages: {
      title: "Kielet",
      error: "Virhe...",
      messages: {
        savedSuccessfully: "Kieliasetukset tallennettu onnistuneesti",
        couldntSave: "Kieliasetuksia ei voitu tallentaa"
      },
      banner: {
        upgradeTitle: "Monikielinen tuki vaatii suunnitelman päivityksen",
        upgradeAction: "Päivitä Superest:iin",
        upgradeMessage: "Voit edelleen muuttaa oletuskielesi, mutta useiden kielten ottaminen käyttöön vaatii päivityksen.",
        disabledMessage: "Monikieliset asetukset ovat pois käytöstä nykyisessä suunnitelmassasi"
      },
      defaultLanguage: {
        title: "Oletuskieli", 
        description: "Valitse ensisijainen kieli, jossa sisältösi näytetään.",
        label: "Oletuskieli",
        help: "Tätä kieltä käytetään, kun tiettyä kieltä ei pyydetä"
      },
      internationalization: {
        title: "Kansainvälistäminen",
        description: "Ota käyttöön useita kieliä. Saavuta enemmän asiakkaita ja paranna SEO:täsi.",
        enableLabel: "Ota käyttöön useita kieliä",
        enableHelp: "Salli asiakkaiden katsella myymälän sijainnin etsijääsi eri kielillä"
      },
      supportedLanguages: {
        title: "Lisäksi tuetut kielet",
        description: "Valitse lisäkielesi, joita haluat tukea. Kun olet ottanut kielen käyttöön, näet vaihtoehdon tarjota käännöksiä koko sovelluksessa. Tuetuille kielille oletus-SEO-pohjat sekä yleiset muuttujateemat luodaan automaattisesti.",
        defaultLocaleNote: "Tämä on oletuskielesi eikä sitä voi poistaa käytöstä",
        shopifyEnabled: {
          label: "Tämä kieli on käytössä Shopify-myymälässäni",
          importantNote: "Tärkeää:",
          description: "Poista yllä olevan ruudun valinta, jos tämä kieli ei ole käytössä ja julkaistu Shopify-myymälässäsi. On suositeltavaa ottaa kieli käyttöön Shopify-myymälässäsi ensin menemällä Asetukset > Kielet Shopify-hallintaan, jos et ole vielä tehnyt sitä sujuvamman asiakaskokemuksen vuoksi."
        },
        urlFormats: {
          cleanUrls: "Puhtaat URL:t:",
          betterSeo: "Parempi SEO ja käyttäjäkokemus",
          queryUrls: "Hakuparametrin URL:t:",
          considerEnabling: "Harkitse ottamista käyttöön Shopify:ssä parempien URL:ien vuoksi"
        },
        preview: {
          button: "Esikatselu",
          tooltip: "Esikatsele {{language}} myymälän sijainnin etsijää"
        },
        tooltips: {
          noTemplates: "Tälle kielelle ei ole oletus-SEO-pohjia saatavilla. Voit luoda mukautettuja käännöksiä helposti."
        }
      }
    },
    tags: {
      title: "Tunnisteet",
      addTag: "Lisää tunniste",
      error: "Virhe",
      messages: {
        deletedSuccessfully: "Tunnisteet poistettu onnistuneesti",
        couldntDelete: "Tunnisteita ei voitu poistaa",
        savedSuccessfully: "Tunniste tallennettu onnistuneesti",
        couldntSave: "Tarkista kenttäsi",
        tagDeleted: "Tunniste poistettu onnistuneesti"
      },
      resourceName: {
        singular: "tunniste",
        plural: "tunnisteet"
      },
      filters: {
        anyGroup: "Mikä tahansa ryhmä",
        inGroup: "Ryhmässä",
        tagGroup: "Tunnisteryhmä"
      },
      appliedFilters: {
        inGroup: "Ryhmässä {{group}}",
        nameContains: "Tunnisteen nimi sisältää {{query}}"
      },
      bulkActions: {
        deleteTag: "Poista tunniste",
        deleteTags: "Poista tunnisteet"
      },
      form: {
        language: "Kieli",
        title: "Otsikko",
        description: "Kuvaus",
        group: "Ryhmä",
        groupPlaceholder: "Valitse ryhmä",
        addGroup: "Lisää",
        editingTranslations: "Muokataan {{language}} käännöksiä. Tyhjät kentät näyttävät sisältöä {{defaultLanguage}}.",
        defaultValue: "Oletus: {{value}}",
        image: "Kuva",
        imageUrl: "Kuvan URL"
      },
      actions: {
        save: "Tallenna",
        deleteTag: "Poista tunniste"
      },
      new: {
        title: "Lisää tunniste",
        messages: {
          createSuccess: "Tunniste luotu onnistuneesti",
          checkFields: "Tarkista kenttäsi"
        },
        actions: {
          createTag: "Luo tunniste"
        }
      }
    },
    customFields: {
      title: "Mukautetut kentät",
      addField: "Lisää kenttä",
      error: "Virhe",
      resourceName: {
        singular: "Kenttä",
        plural: "Kentät"
      },
      headings: {
        name: "Nimi",
        contentType: "Sisältötyyppi",
        usedIn: "Käytetty"
      },
      emptyState: {
        heading: "Luo ja hallitse mukautettuja kenttiäsi",
        createAction: "Luo kenttä",
        description: "Käytä mukautettuja kenttiä ainutlaatuisiin attribuutteihin sijainneistasi. Nämä kentät voivat olla mitä tahansa sosiaalisista profiileista myymälänjohtajan nimeen ja sähköpostiin"
      },
      pluralization: {
        location: "sijainti",
        locations: "sijainnit"
      },
      form: {
        name: "Nimi",
        contentType: "Sisältötyyppi",
        key: "Avain",
        keyPrefix: "location.fields.",
        keyHelp: "Käytä tätä avainta päästäksesi sijainnin {{name}} sisältöön liquid-pohjissasi.",
        translations: {
          title: "Käännökset",
          showTranslations: "Näytä käännökset",
          hideTranslations: "Piilota käännökset",
          description: "Käännökset ovat valinnaisia. Tyhjät kentät näyttävät {{language}} kentän nimen.",
          nameTranslation: "Nimi ({{language}})",
          defaultValue: "Oletus: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Kenttä tallennettu onnistuneesti",
        couldntSave: "Kenttää ei voitu tallentaa",
        deletedSuccessfully: "Kenttä poistettu onnistuneesti",
        couldntDelete: "Kenttää ei voitu poistaa"
      },
      actions: {
        delete: "Poista"
      },
      new: {
        title: "Lisää kenttä",
        messages: {
          savedSuccessfully: "Kenttä tallennettu onnistuneesti",
          couldntSave: "Kenttää ei voitu tallentaa"
        }
      },
      contentTypes: {
        text: "Teksti",
        textArea: "Tekstialue", 
        email: "Sähköposti",
        number: "Numero",
        phoneNumber: "Puhelinnumero",
        time: "Aika",
        url: "URL"
      }
    },
    plan: {
      title: "Suunnitelma",
      error: "Virhe",
      changePlan: "Vaihda suunnitelmaa",
      usdPerMonth: "USD / kuukausi",
      sections: {
        yourPlanIncludes: "Suunnitelmasi sisältää",
        nextBillingDate: "Seuraava laskutuspäivä",
        trial: "Koeaika"
      },
      banners: {
        planUpdated: "Suunnitelmasi on päivitetty",
        thankYouUpgrading: "Kiitos päivityksestä!",
        letUsKnow: "Kerro meille",
        improvementText: "jos voimme tehdä jotain paremmin.",
        trialCancellation: {
          title: "Kokeilujakson peruutuksen ilmoitus",
          message: "14 päivän ilmainen kokeilujakso peruutetaan, kun päivität maksulliseen suunnitelmaan."
        }
      },
      locations: {
        upTo: "Jopa",
        locations: "sijaintia",
        unlimited: "Rajoittamattomat sijainnit",
        used: "käytetty",
        ofUsed: "{{used}} / {{max}} käytetty"
      },
      trial: {
        daysLeft: "{{days}} päivää jäljellä",
        daysUsed: "{{used}} / {{total}} päivää käytetty",
        selectPlan: "Valitse suunnitelma",
        currentPlan: "Nykyinen suunnitelma",
        trialBadge: "Koeaika",
        currentBadge: "Nykyinen",
        yourTrialJustStarted: "Koeaikasi alkoi juuri",
        trialEndsAfterToday: "Koeaikasi päättyy tämän päivän jälkeen",
        trialEndsTomorrow: "Koeaikasi päättyy huomenna",
        daysLeftInTrial: "{{days}} päivää jäljellä koeajassasi",
        continueAddingLocations: "Jatka sijainteja lisäämistä {{date}} jälkeen valitsemalla suunnitelma",
        selectPlanToday: "Valitse suunnitelma tänään jatkaaksesi sijainteja lisäämistä"
      },
      footer: {
        description: "Hallitse tai vaihda Locations So Super -suunnitelmasi. Katso",
        termsOfService: "käyttöehdot",
        and: "ja",
        privacyPolicy: "tietosuojakäytäntö"
      },
      features: {
        analytics: {
          title: "Analytiikka",
          description: "Selvitä, miten ihmiset käyttävät sijaintejasi ja mistä he etsivät"
        },
        internationalization: {
          title: "Monikielinen tuki",
          description: "Paranna SEO:tä ja saavuta enemmän asiakkaita kohdemarkkinoilla ottamalla käyttöön useita kieliä"
        },
        customThemes: {
          editLiquid: {
            title: "Muokkaa teeman liquid-pohjia",
            description: "Näytä sijaintitiedot haluamallasi tavalla pääsyä teeman liquid-pohjiin"
          },
          editStructuredData: {
            title: "Muokkaa yrityksen rakennettuja tietoja",
            description: "Muokkaa, miten Google ymmärtää sivuja muokkaamalla rakennettuja tietojasi"
          }
        }
      },
      edit: {
        title: "Vaihda suunnitelmaa",
        allPlansInclude: "Kaikki yllä olevat suunnitelmat sisältävät",
        needingMoreLocations: "Tarvitsetko enemmän sijainteja?",
        footerQuestion: "Onko kysyttävää ennen aloittamista?",
        sendMessage: "lähetä meille viesti",
        allFeatures: {
          seoDirectory: {
            title: "SEO-hakemisto ja kohdesivut",
            description: "Luo automaattisesti SEO-hakemisto kaikista sijainneistasi, kaupungeistasi ja alueistasi"
          },
          mapPage: {
            title: "Karttasivu haulla ja suodattimella",
            description: "Etsi ja suodata kaikki sijaintisi Mapbox-pohjaisella kartalla"
          },
          tags: {
            title: "Tunnisteet",
            description: "Luo tunnisteita kuvilla ja kuvauksilla ja ryhmittele ne"
          },
          openingHours: {
            title: "Aukioloajat",
            description: "Aseta ja näytä aukioloajat sijainneillesi"
          },
          mapStyles: {
            title: "Karttatyylit",
            description: "Muuta karttojen ulkoasua useilla ennalta määritellyillä tyyleillä"
          },
          customFields: {
            title: "Mukautetut kentät",
            description: "Lisää mitä tahansa uusia kenttiä, sosiaalisista linkeistä myymälänjohtajaan"
          },
          csvUpload: {
            title: "Lataa ja vie CSV:llä",
            description: "Lataa ja muokkaa sijaintisi joukkona."
          },
          richSnippets: {
            title: "Rikkaat katkelmat",
            description: "Auta Googlea ymmärtämään sivuja paremmin paikallisen yrityksen rakennetuilla tiedoilla"
          },
          directionsAndCalls: {
            title: "Reittiohjeet ja puhelut",
            description: "Vierailijat voivat helposti saada reittiohjeet ja soittaa sijainteihin"
          },
          languageSupport: {
            title: "Kielituki",
            description: "Vaihda oletuskieli johonkin muuhun kuin englantiin. Käännöspohjat tarjotaan 32 pääkielelle helpon asennuksen vuoksi."
          }
        }
      },
      planCard: {
        bestToCustomize: "Paras mukautettavaksi",
        currentPlan: "Nykyinen suunnitelma",
        chooseThisPlan: "Valitse tämä suunnitelma",
        locationsSection: "Sijainnit",
        featuresSection: "Ominaisuudet",
        upTo: "Jopa",
        locations: "sijaintia",
        tooltipTooManyLocations: "Sinulla on liian monta sijaintia ja/tai käytössä olevaa kieltä tälle suunnitelmalle."
      },
      confirmation: {
        error: "Virhe suunnitelman vahvistamisessa"
      }
    }
  },

  // Themes section
  themes: {
    title: "Teemat",
    currentTheme: {
      title: "Nykyinen teema",
      description: "Tämä on teema, jonka asiakkaat näkevät vieraillessaan sijaintisovelluksessasi."
    },
    themeLibrary: {
      title: "Teemakirjasto", 
      description: "Hallitse sijaintiteemoja. Lisää ja julkaise teemoja muuttaaksesi online-sijaintisi ulkoasua."
    },
    skeleton: {
      currentThemeDescription: "Tämä on teema, jonka asiakkaasi näkevät käyttäessään sijaintisovellustasi."
    },
    modal: {
      overrideTitle: "Korvata nykyinen teema?",
      override: "Korvaa",
      cancel: "Peruuta",
      undoWarning: "Tätä toimintoa ei voi kumota."
    },
    messages: {
      publishSuccess: "Teema julkaistiin onnistuneesti",
      publishError: "Teemaa ei voitu julkaista",
      error: "Jokin meni pieleen"
    },
    emptyStates: {
      settings: {
        heading: "Tällä teemalla ei ole asetuksia",
        description: "Luo asetukset mallineeditorissa.",
        createSettings: "Luo asetukset",
        upgradePlan: "Päivitä suunnitelma",
        upgradeRequired: "Päivitä suunnitelma asetusten luomiseksi"
      },
      language: {
        heading: "Tällä teemalla ei ole kielitermejä",
        description: "Luo kielitermit mallineeditorissa.",
        createLanguageTerms: "Luo kielitermit",
        upgradePlan: "Päivitä suunnitelma",
        upgradeRequired: "Päivitä suunnitelma kielitermien luomiseksi"
      }
    },
    templates: {
      categories: {
        templates: "Mallineet",
        schemas: "Skeemat",
        styles: "Tyylit",
        liquidReference: "Liquid-viittaus"
      },
      items: {
        landing: "Kohdesivu",
        directory: "Hakemisto",
        country: "Maa",
        region: "Alue",
        city: "Kaupunki",
        location: "Sijainti",
        language: "Kieli",
        settings: "Asetukset",
        stylesheet: "Tyylitiedosto"
      },
      errors: {
        errorsInTemplate: "Virheitä mallineessa",
        error: "Virhe"
      },
      badges: {
        errors: "Virheitä!",
        unsaved: "Tallentamaton"
      },
      actions: {
        viewTheme: "Näytä teema",
        discard: "Hylkää",
        save: "Tallenna"
      }
    },
    language: {
      messages: {
        saveSuccess: "Teeman kielikäännökset tallennettu onnistuneesti",
        saveError: "Teemaa ei voitu tallentaa"
      },
      form: {
        language: "Kieli",
        defaultLanguageHelp: "Tämä on oletuskielesi",
        translationHelp: "Muokataan käännöksiä {{selectedLocale}}. Tyhjät kentät näyttävät sisältöä {{defaultLocale}} (oletuskielesi)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Useita kieliä ei ole käytössä",
          action: "Ota käyttöön asetuksissa",
          description: "Useiden kielten käännösten hallitsemiseksi ota kansainvälistyminen käyttöön kieliasetuksissasi. Näytetään tällä hetkellä vain {{locale}}-käännökset."
        },
        translating: {
          title: "Käännös {{from}} → {{to}}",
          description: "Tyhjiksi jättämäsi kentät näyttävät automaattisesti {{defaultLocale}}-sisällön asiakkaillesi. Käännä vain ne kentät, joissa haluat eri sisällön {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Pääsy {{category}} kielitermejin liquidissä {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Otsikko",
        description: "Kuvaus",
        heading: "Otsikko",
        subheading: "Alaotsikko",
        button_text: "Painikkeen teksti",
        link_text: "Linkin teksti",
        placeholder: "Paikkamerkki",
        label: "Otsikko",
        help_text: "Ohjeteksti",
        error_message: "Virheviesti",
        success_message: "Onnistumisviesti",
        
        // Opening hours
        Monday: "Maanantai",
        Tuesday: "Tiistai",
        Wednesday: "Keskiviikko",
        Thursday: "Torstai",
        Friday: "Perjantai",
        Saturday: "Lauantai",
        Sunday: "Sunnuntai",
        opening_hours_format: "Aukioloaikojen muoto",
        closes_at_format: "Sulkeutumisajan muoto",
        opens_at_format: "Avautumisajan muoto",
        opens_on: "Avautuu",
        open_24h: "Avoinna 24h",
        open: "Avoinna",
        closed: "Suljettu",
        closes_at: "Sulkeutuu",
        opens_at: "Avautuu",
        
        // Map
        search_map: "Etsi kartalta",
        search_area: "Etsi tästä alueesta",
        view_map: "Kartta",
        view_list: "Lista",
        open_filters: "Suodattimet",
        stores_near_you: "Lähelläsi olevat myymälät",
        header: "Löydä myymälä!",
        search_placeholder: "Kirjoita postinumero tai osoite...",
        no_listings: "Valitettavasti emme löydä sijainteja haulle. Kokeile muuttaa suodattimia tai hakupaikkaa",
        
        // Directory
        view_directory: "Myymälähakemisto",
        
        // Location
        get_directions: "Reittiohjeet",
        call: "Soita",
        view_website: "Verkkosivusto",
        email: "Sähköposti",
        opening_hours_header: "Aukioloajat",
        description_header: "Tiedot",
        phone_number_header: "Puhelin",
        address_header: "Osoite",
        tag_groups_to_display: "Näytettävät tunnisteryhmät"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Yleinen",
        navigation: "Navigointi",
        forms: "Lomakkeet",
        buttons: "Painikkeet",
        messages: "Viestit",
        errors: "Virheet",
        opening_hours: "Aukioloajat",
        map: "Kartta",
        directory: "Hakemisto",
        location: "Sijainti"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Teema tallennettu onnistuneesti",
        saveError: "Teemaa ei voitu tallentaa"
      },
      accessSettings: "Pääsy {{category}} asetuksiin liquidissä {{code}}",
      fields: {
        // Colors
        color_text: "Tekstin väri",
        color_text_heading: "Otsikon tekstin väri", 
        color_background: "Taustaväri",
        color_accent: "Korostusväri",
        color_text_positive: "Positiivisen tekstin väri",
        color_text_negative: "Negatiivisen tekstin väri",
        dark_theme: "Tumma teema",
        color_marker: "Merkkiväri",
        color_search_marker: "Hakumerkin väri",
        
        // Typography
        base_font_size: "Perusfonttikoko",
        
        // Buttons
        border_radius: "Reunan säde",
        
        // Images
        aspect_ratio: "Kuvasuhde",
        fit: "Sovitus",
        
        // Spacing
        page_width: "Sivun leveys",
        page_width_small: "Pieni sivun leveys",
        gutter_desktop: "Työpöytäreuna",
        gutter_mobile: "Mobiilireuna",
        desktop_vertical_spacing: "Työpöydän pystyvälistys",
        mobile_vertical_spacing: "Mobiilin pystyvälistys",
        
        // Breakpoints
        breakpoint_xs: "Katkaisupiste XS",
        breakpoint_sm: "Katkaisupiste SM",
        breakpoint_md: "Katkaisupiste MD",
        
        // Map
        search_on_move: "Hae liikkuessa",
        scroll_to_zoom: "Vieritä zoomataksesi",
        
        // Landing page
        sidebar_width: "Sivupalkin leveys",
        sidebar_min_height: "Sivupalkin minimikorkeus",
        marker_image_src: "Merkkikuvan lähde",
        show_filter_descriptions: "Näytä suodattimien kuvaukset",
        
        // Location page
        tag_groups_to_display: "Näytettävät tunnisteryhmät",
        tag_groups_to_display_as_icons: "Kuvakkeina näytettävät tunnisteryhmät",
        show_related_locations: "Näytä liittyvät sijainnit",
        
        // Locations
        hide_regions: "Piilota alueet"
      },
      categories: {
        colors: "Värit",
        typography: "Typografia",
        buttons: "Painikkeet",
        images: "Kuvat",
        spacing: "Välistys",
        breakpoints: "Katkaisupisteet",
        map: "Kartta",
        landing_page: "Kohdesivu",
        location_page: "Sijaintisivu",
        locations: "Sijainnit"
      }
    },
    navigation: {
      sublimeTheme: "Sublime-teema",
      settings: "Asetukset",
      language: "Kieli",
      templates: "Mallineet",
      changeTheme: "Vaihda teemaa",
      viewDirectory: "Näytä hakemisto",
      viewLandingPage: "Näytä kohdesivu"
    },
    card: {
      lastUpdated: "Viimeksi päivitetty",
      view: "Näytä",
      customize: "Mukauta",
      publish: "Julkaise",
      actions: "Toiminnot"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytiikka",
    timePeriods: {
      last7days: "Viimeiset 7 päivää",
      last30days: "Viimeiset 30 päivää"
    },
    comparison: {
      compareToPrevious: "Vertaa edelliseen jaksoon",
      stopComparing: "Lopeta vertailu edelliseen jaksoon"
    },
    sections: {
      searchLocations: "Etsi sijainteja"
    },
    cards: {
      sessions: "Istunnot",
      topSearches: "Suosituimmat haut",
      topLandingPageType: "Suosituin kohdesivutyyppi",
      topPageViewsBySession: "Suosituimmat sivunäkymät istuntoa kohden",
      topLocations: "Suosituimmat sijainnit",
      topReferrers: "Suosituimmat viittaajat",
      searches: "Haut",
      topLandingPagesBySession: "Suosituimmat kohdesivut istuntoa kohden"
    },
    chartLabels: {
      desktop: "Työpöytä"
    }
  },

}; 